import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=a05c7bf2&scoped=true&"
var script = {}
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=a05c7bf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c7bf2",
  null
  
)

export default component.exports